import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NavbarComponent } from './navbar/navbar.component';

import { CategoryComponent } from './category/category.component';
import { ProjectComponent } from './project/project.component';
import { MailerComponent } from './mailer/mailer.component';
import{TemplateComponent} from './template/template.component';
import {DashboardComponent} from './dashboard/dashboard.component';

import {LoginComponent} from './login/login.component';



const routes: Routes = [
  {path : "category/add",component : CategoryComponent},
  {path : "category/:id",component : CategoryComponent},
  {path : "category",component : CategoryComponent},
  {path : "project/add",component : ProjectComponent},
  {path : "project/:id",component : ProjectComponent},
  {path : "project",component : ProjectComponent},
  {path : "mailer/add",component : MailerComponent},
  {path : "mailer",component : MailerComponent},
  {path : "template/add",component : TemplateComponent},
  {path : "template/edit/:id",component : TemplateComponent},
  {path : "template",component : TemplateComponent},
  {path : "login",component : LoginComponent},
  {path : "**",component : DashboardComponent}
  
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/app-routing.module.ts